<template>
  <div>
    <p class="response-title">文本系列</p>
    <p class="response-h">创建文本对话请求</p>
    <p class="response-d">
      Creates a model response for the given chat conversation.
    </p>
    <div class="response-i">
      <div class="response-i-box">
        <span class="left">POST</span> <span>/v1/chat/completions</span>
      </div>
      <!-- <div class="response-btn">Try it</div> -->
    </div>
    <div class="response-next">
      <p class="next-title">Authorizations</p>
      <el-divider class="response-line"></el-divider>
      <div>
        <span class="next-d">Authorization</span
        ><el-tag type="info" size="mini">string</el-tag
        ><el-tag type="info" size="mini">header</el-tag
        ><el-tag type="danger" size="mini">required</el-tag>
      </div>
      <p class="next-a">
        Use the following format for authentication: Bearer
        &lt;your api key&gt;
      </p>
    </div>
    <div class="response-next">
      <p class="next-title">
        Body<span
          style="
            float: right;
            font-size: 0.75rem;
            margin-top: 7px;
            font-weight: 500;
            color: rgb(86 84 90);
          "
          >application/json</span
        >
      </p>
      <el-divider class="response-line"></el-divider>
      <el-card shadow="never">
        <el-tabs v-model="nextActive" @tab-click="handleClick">
          <el-tab-pane label="LLM" name="LLM">
            <div>
              <span class="next-d">model</span
              ><el-tag type="info" size="mini">{{ model }}</el-tag
              ><el-tag type="info" size="mini">default:Qwen/QwQ-32B</el-tag
              ><el-tag type="danger" size="mini">required</el-tag>
            </div>
            <p class="nex-c">
              Corresponding Model Name. To better enhance service quality, we
              will make periodic changes to the models provided by this service,
              including but not limited to model on/offlining and adjustments to
              model service capabilities. We will notify you of such changes
              through appropriate means such as announcements or message pushes
              where feasible.
            </p>
            <div style="margin-top: 2vh" class="next-p">
              <span style="margin-right: 5px">Available options:</span>
              <el-tag type="info" size="mini">Qwen/QwQ-32B</el-tag>,
              <el-tag type="info" size="mini"
                >Pro/deepseek-ai/DeepSeek-R1</el-tag
              >,
              <el-tag type="info" size="mini"
                >Pro/deepseek-ai/DeepSeek-V3</el-tag
              >,
              <el-tag type="info" size="mini">deepseek-ai/DeepSeek-R1</el-tag>,
              <el-tag type="info" size="mini">deepseek-ai/DeepSeek-V3</el-tag>,
              <el-tag type="info" size="mini"
                >deepseek-ai/DeepSeek-R1-Distill-Qwen-32B</el-tag
              >,
              <el-tag type="info" size="mini"
                >deepseek-ai/DeepSeek-R1-Distill-Qwen-14B</el-tag
              >,
              <el-tag type="info" size="mini"
                >deepseek-ai/DeepSeek-R1-Distill-Qwen-7B</el-tag
              >,
              <el-tag type="info" size="mini"
                >deepseek-ai/DeepSeek-R1-Distill-Qwen-1.5B</el-tag
              >,
              <el-tag type="info" size="mini"
                >Pro/deepseek-ai/DeepSeek-R1-Distill-Qwen-7B</el-tag
              >,
              <el-tag type="info" size="mini"
                >Pro/deepseek-ai/DeepSeek-R1-Distill-Qwen-1.5B</el-tag
              >,
              <el-tag type="info" size="mini">deepseek-ai/DeepSeek-V2.5</el-tag
              >,
              <el-tag type="info" size="mini"
                >Qwen/Qwen2.5-72B-Instruct-128K</el-tag
              >,
              <el-tag type="info" size="mini">Qwen/Qwen2.5-72B-Instruct</el-tag
              >,
              <el-tag type="info" size="mini">Qwen/Qwen2.5-32B-Instruct</el-tag
              >,
              <el-tag type="info" size="mini">Qwen/Qwen2.5-14B-Instruct</el-tag
              >,
              <el-tag type="info" size="mini">Qwen/Qwen2.5-7B-Instruct</el-tag>,
              <el-tag type="info" size="mini"
                >Qwen/Qwen2.5-Coder-32B-Instruct</el-tag
              >,
              <el-tag type="info" size="mini"
                >Qwen/Qwen2.5-Coder-7B-Instruct</el-tag
              >,
              <el-tag type="info" size="mini">Qwen/Qwen2-7B-Instruct</el-tag>,
              <el-tag type="info" size="mini">Qwen/Qwen2-1.5B-Instruct</el-tag>,
              <el-tag type="info" size="mini">Qwen/QwQ-32B-Preview</el-tag>,
              <el-tag type="info" size="mini">TeleAI/TeleChat2</el-tag>,
              <el-tag type="info" size="mini">THUDM/glm-4-9b-chat</el-tag>,
              <el-tag type="info" size="mini"
                >Vendor-A/Qwen/Qwen2.5-72B-Instruct</el-tag
              >,
              <el-tag type="info" size="mini"
                >internlm/internlm2_5-7b-chat</el-tag
              >,
              <el-tag type="info" size="mini"
                >internlm/internlm2_5-20b-chat</el-tag
              >,
              <el-tag type="info" size="mini"
                >Pro/Qwen/Qwen2.5-7B-Instruct</el-tag
              >,
              <el-tag type="info" size="mini">Pro/Qwen/Qwen2-7B-Instruct</el-tag
              >,
              <el-tag type="info" size="mini"
                >Pro/Qwen/Qwen2-1.5B-Instruct</el-tag
              >, <el-tag type="info" size="mini">Pro/THUDM/chatglm3-6b</el-tag>,
              <el-tag type="info" size="mini">Pro/THUDM/glm-4-9b-chat</el-tag>
            </div>
            <div style="margin-top: 25px">
              <span style="margin-right: 5px">Example:</span>
              <el-tag type="info" size="mini">Qwen/QwQ-32B</el-tag>
            </div>
            <el-divider></el-divider>
          </el-tab-pane>
          <el-tab-pane label="VLM" name="VLM">
            <div>
              <span class="next-d">model</span
              ><el-tag type="info" size="mini">{{ model }}</el-tag
              ><el-tag type="info" size="mini"
                >default:Qwen/Qwen2.5-VL-72B-Instruct</el-tag
              ><el-tag type="danger" size="mini">required</el-tag>
            </div>
            <p class="nex-c">
              Corresponding Model Name. To better enhance service quality, we
              will make periodic changes to the models provided by this service,
              including but not limited to model on/offlining and adjustments to
              model service capabilities. We will notify you of such changes
              through appropriate means such as announcements or message pushes
              where feasible.
            </p>
            <div style="margin-top: 2vh" class="next-p">
              <span style="margin-right: 5px">Available options:</span>
              <el-tag type="info" size="mini"
                >Qwen/Qwen2.5-VL-32B-Instruct</el-tag
              >,
              <el-tag type="info" size="mini"
                >Qwen/Qwen2.5-VL-72B-Instruct</el-tag
              >, <el-tag type="info" size="mini">Qwen/QVQ-72B-Preview</el-tag>,
              <el-tag type="info" size="mini">deepseek-ai/deepseek-vl2</el-tag>,
              <el-tag type="info" size="mini">Qwen/Qwen2-VL-72B-Instruct</el-tag
              >,
              <el-tag type="info" size="mini"
                >Pro/Qwen/Qwen2-VL-7B-Instruct</el-tag
              >,
              <el-tag type="info" size="mini"
                >Pro/Qwen/Qwen2.5-VL-7B-Instruct</el-tag
              >
            </div>
            <div style="margin-top: 25px">
              <span style="margin-right: 5px">Example:</span>
              <el-tag type="info" size="mini"
                >"Qwen/Qwen2.5-VL-72B-Instruct"</el-tag
              >
            </div>
            <el-divider></el-divider>
          </el-tab-pane>
        </el-tabs>
        <div>
          <span class="next-d">messages</span
          ><el-tag type="info" size="mini">object [ ]</el-tag
          ><el-tag type="danger" size="mini">required</el-tag>
        </div>
        <p class="nex-c">
          A list of messages comprising the conversation so far.
        </p>
        <el-collapse style="margin-bottom: 24px" @change="sfqChange">
          <el-collapse-item :title="sfqTile" name="1">
            <div>
              messages <span class="next-d">.role</span>
              <el-tag type="info" size="mini">{{ model }} </el-tag
              ><el-tag type="info" size="mini">default:user</el-tag
              ><el-tag type="danger" size="mini">required</el-tag>
            </div>
            <p class="nex-c" style="margin-top: 20px">
              The role of the messages author. Choice between: system, user, or
              assistant.
            </p>
            <div style="margin-top: 25px">
              <span style="margin-right: 5px">Available options:</span>
              <el-tag type="info" size="mini">user</el-tag>,
              <el-tag type="info" size="mini">assistant</el-tag>,
              <el-tag type="info" size="mini">system</el-tag>
            </div>
            <div style="margin-top: 25px">
              <span style="margin-right: 5px">Example:</span>
              <el-tag type="info" size="mini">"user"</el-tag>
            </div>
            <el-divider></el-divider>
            <div>
              messages <span class="next-d">.content</span><br />
              <el-tag type="info" size="mini">string</el-tag
              ><el-tag type="info" size="mini"
                >default:What opportunities and challenges will the Chine se
                large model industry face in 2025?</el-tag
              ><el-tag type="danger" size="mini">required</el-tag>
            </div>
            <p class="nex-c" style="margin-top: 20px">
              The contents of the message.
            </p>
            <div style="margin-top: 25px">
              <span style="margin-right: 5px">Example:</span>
              <el-tag type="info" size="mini"
                >"What opportunities and challenges will the Chinese large model
                industry face in 2025?"</el-tag
              >
            </div>
          </el-collapse-item>
        </el-collapse>
        <div>
          <span class="next-d">stream</span
          ><el-tag type="info" size="mini">boolean</el-tag
          ><el-tag type="danger" size="mini">default:false</el-tag>
        </div>
        <p class="nex-c">
          If set, tokens are returned as Server-Sent Events as they are made
          available. Stream terminates with
          <el-tag type="info" size="mini">data: [DONE]</el-tag>
        </p>
        <div style="margin-top: 25px">
          <span style="margin-right: 5px">Example:</span>
          <el-tag type="info" size="mini">false</el-tag>
        </div>
        <!------->
        <el-divider></el-divider>
        <div>
          <span class="next-d">max_tokens</span
          ><el-tag type="info" size="mini">integer</el-tag
          ><el-tag type="info" size="mini">default:512</el-tag>
        </div>
        <p class="nex-c">The maximum number of tokens to generate.</p>
        <p class="nex-c">
          Required range:
          <el-tag type="info" size="mini">1 <= x <= 16384</el-tag>
        </p>
        <div style="margin-top: 25px">
          <span style="margin-right: 5px">Example:</span>
          <el-tag type="info" size="mini">512</el-tag>
        </div>

        <el-divider></el-divider>
        <div>
          <span class="next-d">stop</span>
          <el-select
            v-model="stopValue"
            placeholder="请选择"
            size="mini"
            style="width: 120px"
          >
            <el-option label="string | null" value="string | null"> </el-option>
            <el-option label="string [ ] | null" value="string [ ] | null">
            </el-option>
          </el-select>
        </div>
        <p class="nex-c">
          Up to 4 sequences where the API will stop generating further tokens.
          The returned text will not contain the stop sequence.
        </p>

        <div style="margin-top: 25px" v-if="stopValue == 'string | null'">
          <span style="margin-right: 5px">Example:</span>
          <el-tag type="info" size="mini">null</el-tag>
        </div>
        <!------->
        <el-divider></el-divider>
        <div>
          <span class="next-d">temperature</span
          ><el-tag type="info" size="mini">number</el-tag
          ><el-tag type="info" size="mini">default::0.7</el-tag>
        </div>
        <p class="nex-c">
          Determines the degree of randomness in the response.
        </p>
        <div style="margin-top: 25px" v-if="stopValue == 'string | null'">
          <span style="margin-right: 5px">Example:</span>
          <el-tag type="info" size="mini">0.7</el-tag>
        </div>
        <!------->
        <el-divider></el-divider>
        <div>
          <span class="next-d">top_p</span
          ><el-tag type="info" size="mini">number</el-tag
          ><el-tag type="info" size="mini">default::0.7</el-tag>
        </div>
        <p class="nex-c">
          The <el-tag type="info" size="mini">top_p</el-tag>(nucleus) parameter
          is used to dynamically adjust the number of choices for each predicted
          token based on the cumulative probabilities.
        </p>
        <div style="margin-top: 25px" v-if="stopValue == 'string | null'">
          <span style="margin-right: 5px">Example:</span>
          <el-tag type="info" size="mini">0.7</el-tag>
        </div>
        <!---->
        <el-divider></el-divider>
        <div>
          <span class="next-d">top_k</span
          ><el-tag type="info" size="mini">number</el-tag
          ><el-tag type="info" size="mini">default:50</el-tag>
        </div>
        <!-- <p class="nex-c">
              The <el-tag type="info" size="mini">top_p</el-tag>(nucleus) parameter is used to dynamically adjust the number of choices for each predicted token based on the cumulative probabilities.
            </p> -->
        <div style="margin-top: 25px" v-if="stopValue == 'string | null'">
          <span style="margin-right: 5px">Example:</span>
          <el-tag type="info" size="mini">50</el-tag>
        </div>
        <!---->
        <!---->
        <el-divider></el-divider>
        <div>
          <span class="next-d">frequency_penalty</span
          ><el-tag type="info" size="mini">number</el-tag
          ><el-tag type="info" size="mini">default:0.5</el-tag>
        </div>
        <!-- <p class="nex-c">
              The <el-tag type="info" size="mini">top_p</el-tag>(nucleus) parameter is used to dynamically adjust the number of choices for each predicted token based on the cumulative probabilities.
            </p> -->
        <div style="margin-top: 25px" v-if="stopValue == 'string | null'">
          <span style="margin-right: 5px">Example:</span>
          <el-tag type="info" size="mini">0.5</el-tag>
        </div>
        <!---->
        <!---->
        <el-divider></el-divider>
        <div>
          <span class="next-d">n</span
          ><el-tag type="info" size="mini">integer</el-tag
          ><el-tag type="info" size="mini">default:1</el-tag>
        </div>
        <p class="nex-c">Number of generations to return</p>
        <div style="margin-top: 25px" v-if="stopValue == 'string | null'">
          <span style="margin-right: 5px">Example:</span>
          <el-tag type="info" size="mini">1</el-tag>
        </div>
        <!---->
        <el-divider></el-divider>
        <div>
          <span class="next-d">response_format</span>
          <el-tag type="info" size="mini">object</el-tag>
        </div>
        <div></div>
        <p class="nex-c">
          An object specifying the format that the model must output.
        </p>
        <el-collapse style="margin-bottom: 24px" @change="anChange">
          <el-collapse-item :title="anTitle" name="1">
            <div>
              response_format <span class="next-d">.type</span>
              <el-tag type="info" size="mini"> string </el-tag>
            </div>
            <p class="nex-c" style="margin-top: 20px">
              The type of the response format.
            </p>
            <div style="margin-top: 25px">
              <span style="margin-right: 5px">Example:</span>
              <el-tag type="info" size="mini">"text"</el-tag>
            </div>
          </el-collapse-item>
        </el-collapse>
        <!-- <div style="margin-top: 25px" v-if="stopValue == 'string | null'">
              <span style="margin-right: 5px">Example:</span>
              <el-tag type="info" size="mini">null</el-tag>
            </div> -->
        <!----->

        <div>
          <span class="next-d">tools</span
          ><el-tag type="info" size="mini">object [ ]</el-tag>
        </div>
        <p class="nex-c">
          A list of tools the model may call. Currently, only functions are
          supported as a tool. Use this to provide a list of functions the model
          may generate JSON inputs for. A max of 128 functions are supported.
        </p>
        <el-collapse style="margin-bottom: 24px" @change="tooChange">
          <el-collapse-item :title="tooTitle" name="1">
            <div>
              tools <span class="next-d">.type</span>
              <el-tag type="info" size="mini"> {{ model }} </el-tag>
              <el-tag type="danger" size="mini">required</el-tag>
            </div>
            <p class="nex-c" style="margin-top: 20px">
              The type of the tool. Currently, only
              <el-tag type="info" size="mini">function</el-tag> is supported.
            </p>
            <div style="margin-top: 25px">
              <span style="margin-right: 5px">Available options:</span>
              <el-tag type="info" size="mini">function</el-tag>
            </div>
            <el-divider></el-divider>
            <div>
              tools <span class="next-d">.function</span>
              <el-tag type="info" size="mini"> object</el-tag>
              <el-tag type="danger" size="mini">required</el-tag>
            </div>
            <el-collapse
              style="margin-bottom: 24px"
              @change="meChange"
              class="hideLine"
            >
              <el-collapse-item :title="meTitle" name="1">
                <div>
                  tools.function <span class="next-d">.name</span>
                  <el-tag type="info" size="mini"> string </el-tag>

                  <el-tag type="danger" size="mini">required</el-tag>
                </div>
                <p class="nex-c" style="margin-top: 20px">
                  The type of the response format.
                </p>
                <div style="margin-top: 25px">
                  <span style="margin-right: 5px">Example:</span>
                  <el-tag type="info" size="mini">"text"</el-tag>
                </div>
                <p class="nex-c" style="margin-top: 20px">
                  TThe name of the function to be called. Must be a-z, A-Z, 0-9,
                  or contain underscores and dashes, with a maximum length of
                  64.
                </p>
                <el-divider></el-divider>
                <div>
                  tools.function <span class="next-d">.description</span>
                  <el-tag type="info" size="mini"> string </el-tag>

                  <el-tag type="danger" size="mini">required</el-tag>
                </div>
                <p class="nex-c" style="margin-top: 20px">
                  A description of what the function does, used by the model to
                  choose when and how to call the function.
                </p>
                <el-divider></el-divider>
                <div>
                  tools.function <span class="next-d">.parameters</span>
                  <el-tag type="info" size="mini"> string </el-tag>
                </div>
                <p class="nex-c next-a" style="margin-top: 20px">
                  The parameters the functions accepts, described as a JSON
                  Schema object. See the <a href="#">guide </a>for examples, and
                  the <a href="#">JSON Schema reference </a>for documentation
                  about the format.
                </p>
                <p class="nex-c">
                  Omitting
                  <el-tag type="info" size="mini"> parameters </el-tag> defines
                  a function with an empty parameter list.
                </p>
                <el-divider></el-divider>
                <div>
                  tools.function <span class="next-d">.strict</span>
                  <el-tag type="info" size="mini"> boolean | null </el-tag>
                  <el-tag type="info" size="mini"> default:false </el-tag>
                </div>
                <p class="nex-c next-a" style="margin-top: 20px">
                  Whether to enable strict schema adherence when generating the
                  function call. If set to true, the model will follow the exact
                  schema defined in the parameters field. Only a subset of JSON
                  Schema is supported when strict is true. Learn more about
                  Structured Outputs in the
                  <a href="#">function calling guide</a>.
                </p>
              </el-collapse-item>
            </el-collapse>
          </el-collapse-item>
        </el-collapse>
      </el-card>
      <p class="next-title">
        Response<span class="lineSelect">
          <!-- <el-dropdown @click="zlClick">
            <span class="el-dropdown-link">
              application/json<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>application/json</el-dropdown-item>
              <el-dropdown-item>text/event-stream</el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown> -->
          <el-select
            v-if="valueNum == '200'"
            v-model="valueType"
            size="mini"
            @change="zlClick"
            class="lineSelect"
          >
            <el-option label="application/json" value="application/json">
            </el-option>
            <el-option label="text/event-stream" value="text/event-stream">
            </el-option>
          </el-select>
          <span
            style="margin-right: 46px; line-height: 30px; font-size: 12px"
            v-else
            >application/json</span
          >
        </span>
        <span class="lineSelect lineSelect-num">
          <el-select
            v-model="valueNum"
            size="mini"
            @change="numClick"
            class="lineSelect"
          >
            <el-option label="200" value="200"> </el-option>
            <el-option label="400" value="400"> </el-option>
            <el-option label="401" value="401"> </el-option>
            <el-option label="404" value="404"> </el-option>
            <el-option label="429" value="429"> </el-option>
            <el-option label="503" value="503"> </el-option>
            <el-option label="504" value="504"> </el-option>
          </el-select>
        </span>
      </p>

      <!----->

      <el-divider class="response-line"></el-divider>
      <div v-if="numellJson">
        <div style="margin-bottom: 20px">200</div>
        <div>
          <span class="next-d">id</span
          ><el-tag type="info" size="mini">string</el-tag>
        </div>
        <el-divider></el-divider>
        <div>
          <span class="next-d">choices</span
          ><el-tag type="info" size="mini">object [ ]</el-tag>
        </div>
        <el-collapse style="margin-bottom: 24px" @change="choChange">
          <el-collapse-item :title="choTitle" name="1">
            <div>
              choices <span class="next-d">.message</span>
              <el-tag type="info" size="mini"> object</el-tag>
            </div>

            <el-collapse
              style="margin-bottom: 24px"
              @change="objChange"
              class="hideLine"
            >
              <el-collapse-item :title="objTitle" name="1">
                <div>
                  choices.message. <span class="next-d">.role</span>
                  <el-tag type="info" size="mini"> string </el-tag>
                </div>
                <!-- <p class="nex-c" style="margin-top: 20px">
                  The type of the response format.
                </p> -->
                <div style="margin-top: 25px">
                  <span style="margin-right: 5px">Example:</span>
                  <el-tag type="info" size="mini">"assistant"</el-tag>
                </div>
                <el-divider></el-divider>
                <div>
                  choices.message. <span class="next-d">.content</span>
                  <el-tag type="info" size="mini"> string </el-tag>
                </div>
                <el-divider></el-divider>
                <div>
                  choices.message.
                  <span class="next-d">.reasoning_content</span>
                  <el-tag type="info" size="mini"> string </el-tag>
                </div>
                <p class="nex-c" style="margin-top: 20px">
                  Only the deepseek-R1 series and Qwen/QwQ-32B models support
                  reasoning_content. This part returns the reasoning content,
                  which is at the same level as the content. In each round of
                  the conversation, the model outputs the reasoning chain
                  content (reasoning_content) and the final answer (content). In
                  the next round of the conversation, the reasoning chain
                  content from previous rounds will not be appended to the
                  context.
                </p>
                <el-divider></el-divider>
                <div>
                  choices.message.<span class="next-d">.tool_calls</span>
                  <el-tag type="info" size="mini"> object [ ] </el-tag>
                </div>
                <p class="nex-c" style="margin-top: 20px">
                  The tool calls generated by the model, such as function calls.
                </p>
                <el-collapse style="margin-bottom: 24px" @change="mesChange">
                  <el-collapse-item :title="mesTitle" name="1">
                    <div>
                      choices.message.tool_calls <span class="next-d">.id</span>
                      <el-tag type="info" size="mini"> string </el-tag>
                      <el-tag type="danger" size="mini"> required </el-tag>
                    </div>
                    <p class="nex-c" style="margin-top: 20px">
                      The ID of the tool call.
                    </p>
                    <el-divider></el-divider>
                    <div>
                      choices.message.tool_calls
                      <span class="next-d">.type</span>
                      <el-tag type="info" size="mini"> {{ model }} </el-tag>
                      <el-tag type="danger" size="mini"> required </el-tag>
                    </div>
                    <p class="nex-c" style="margin-top: 20px">
                      The type of the tool. Currently, only
                      <el-tag type="info" size="mini">function </el-tag> is
                      supported.
                    </p>
                    <div style="margin-top: 25px">
                      <span style="margin-right: 5px">Available options:</span>
                      <el-tag type="info" size="mini">function</el-tag>
                    </div>
                    <el-divider></el-divider>
                    <div>
                      choices.message.tool_calls
                      <span class="next-d">.function</span>
                      <el-tag type="info" size="mini"> object </el-tag>
                      <el-tag type="danger" size="mini"> required </el-tag>
                    </div>
                    <p class="nex-c" style="margin-top: 20px">
                      The function that the model called.
                    </p>
                    <el-collapse style="margin-bottom: 24px" @change="callChange">
                      <el-collapse-item :title="callTitle" name="1">
                        <div>
                          ​ choices.message.tool_calls.function<span
                            class="next-d"
                            >.name</span
                          >
                          <el-tag type="info" size="mini"> string </el-tag>
                          <el-tag type="danger" size="mini"> required </el-tag>
                        </div>
                        <p class="nex-c" style="margin-top: 20px">
                          The name of the function to call.
                        </p>
                        <el-divider></el-divider>
                        <div>
                          choices.message.tool_calls.function<span
                            class="next-d"
                            >.arguments</span
                          >
                          <el-tag type="info" size="mini"> string </el-tag>
                          <el-tag type="danger" size="mini"> required </el-tag>
                        </div>
                        <p class="nex-c" style="margin-top: 20px">
                          The arguments to call the function with, as generated
                          by the model in JSON format. Note that the model does
                          not always generate valid JSON, and may hallucinate
                          parameters not defined by your function schema.
                          Validate the arguments in your code before calling
                          your function.
                        </p>
                      </el-collapse-item>
                    </el-collapse>
                  </el-collapse-item>
                </el-collapse>
                <el-divider></el-divider>
                <div>
                  tools.function <span class="next-d">.parameters</span>
                  <el-tag type="info" size="mini"> string </el-tag>
                </div>
                <p class="nex-c next-a" style="margin-top: 20px">
                  The parameters the functions accepts, described as a JSON
                  Schema object. See the <a href="#">guide </a>for examples, and
                  the <a href="#">JSON Schema reference </a>for documentation
                  about the format.
                </p>
                <p class="nex-c">
                  Omitting
                  <el-tag type="info" size="mini"> parameters </el-tag> defines
                  a function with an empty parameter list.
                </p>
                <el-divider></el-divider>
                <div>
                  tools.function <span class="next-d">.strict</span>
                  <el-tag type="info" size="mini"> boolean | null </el-tag>
                  <el-tag type="info" size="mini"> default:false </el-tag>
                </div>
                <p class="nex-c next-a" style="margin-top: 20px">
                  Whether to enable strict schema adherence when generating the
                  function call. If set to true, the model will follow the exact
                  schema defined in the parameters field. Only a subset of JSON
                  Schema is supported when strict is true. Learn more about
                  Structured Outputs in the
                  <a href="#">function calling guide</a>.
                </p>
              </el-collapse-item>
            </el-collapse>
            <div>
              choices <span class="next-d">.finish_reason
              </span>
              <el-tag type="info" size="mini">{{  model}}</el-tag>
            </div>
            <div style="margin-top: 25px" v-if="stopValue == 'string | null'">
          <span style="margin-right: 5px">Available options:</span>
          <el-tag type="info" size="mini"> stop</el-tag>,
          <el-tag type="info" size="mini"> length</el-tag>,
          <el-tag type="info" size="mini"> tool_calls</el-tag>

        </div>
          </el-collapse-item>
        </el-collapse>
        <!----->

        <div>
          <span class="next-d">usage</span
          ><el-tag type="info" size="mini">object</el-tag>
        </div>
        <el-collapse style="margin-bottom: 24px" @change="usaChange">
          <el-collapse-item :title="usaTitle" name="1">
            <div>
              
            usage <span class="next-d">.prompt_tokens
              </span>
              <el-tag type="info" size="mini">integer</el-tag>
            </div>
            <el-divider></el-divider>
            <div>
              
              usage <span class="next-d">.completion_tokens
                </span>
                <el-tag type="info" size="mini">integer</el-tag>
              </div>
              <el-divider></el-divider>
              <div>
              
              usage <span class="next-d">.total_tokens
                </span>
                <el-tag type="info" size="mini">integer</el-tag>
              </div>
          
          </el-collapse-item>
        </el-collapse>

        <div>
          <span class="next-d">created</span
          ><el-tag type="info" size="mini">integer</el-tag>
        </div>
        <el-divider></el-divider>
        <div>
          <span class="next-d">model</span
          ><el-tag type="info" size="mini">string</el-tag>
        </div>
        <el-divider></el-divider>
        <div>
          <span class="next-d">object</span
          ><el-tag type="info" size="mini">{{ menu }}</el-tag>
        </div>

        <div style="margin-top: 25px" v-if="stopValue == 'string | null'">
          <span style="margin-right: 5px">Available options:</span>
          <el-tag type="info" size="mini"> chat.completion </el-tag>
        </div>
      </div>
      <div v-if="numellText">
        <div style="margin-bottom: 20px">200</div>
        <div>
          <span class="next-d">id</span
          ><el-tag type="info" size="mini">string</el-tag>
        </div>
        <el-divider></el-divider>
        <div>
          <span class="next-d">choices</span
          ><el-tag type="info" size="mini">object [ ]</el-tag>
        </div>
        <el-collapse style="margin-bottom: 24px" @change="choChange">
          <el-collapse-item :title="choTitle" name="1">
            <div>
              choices <span class="next-d">.message</span>
              <el-tag type="info" size="mini"> object</el-tag>
            </div>

            <el-collapse
              style="margin-bottom: 24px"
              @change="objChange"
              class="hideLine"
            >
              <el-collapse-item :title="objTitle" name="1">
                <div>
                  choices.message. <span class="next-d">.role</span>
                  <el-tag type="info" size="mini"> string </el-tag>
                </div>
                <!-- <p class="nex-c" style="margin-top: 20px">
                  The type of the response format.
                </p> -->
                <div style="margin-top: 25px">
                  <span style="margin-right: 5px">Example:</span>
                  <el-tag type="info" size="mini">"assistant"</el-tag>
                </div>
                <el-divider></el-divider>
                <div>
                  choices.message. <span class="next-d">.content</span>
                  <el-tag type="info" size="mini"> string </el-tag>
                </div>
                <el-divider></el-divider>
                <div>
                  choices.message.
                  <span class="next-d">.reasoning_content</span>
                  <el-tag type="info" size="mini"> string </el-tag>
                </div>
                <p class="nex-c" style="margin-top: 20px">
                  Only the deepseek-R1 series and Qwen/QwQ-32B models support
                  reasoning_content. This part returns the reasoning content,
                  which is at the same level as the content. In each round of
                  the conversation, the model outputs the reasoning chain
                  content (reasoning_content) and the final answer (content). In
                  the next round of the conversation, the reasoning chain
                  content from previous rounds will not be appended to the
                  context.
                </p>
                <el-divider></el-divider>
                <div>
                  choices.message.<span class="next-d">.tool_calls</span>
                  <el-tag type="info" size="mini"> object [ ] </el-tag>
                </div>
                <p class="nex-c" style="margin-top: 20px">
                  The tool calls generated by the model, such as function calls.
                </p>
                <el-collapse style="margin-bottom: 24px" @change="mesChange">
                  <el-collapse-item :title="mesTitle" name="1">
                    <div>
                      choices.message.tool_calls <span class="next-d">.id</span>
                      <el-tag type="info" size="mini"> string </el-tag>
                      <el-tag type="danger" size="mini"> required </el-tag>
                    </div>
                    <p class="nex-c" style="margin-top: 20px">
                      The ID of the tool call.
                    </p>
                    <el-divider></el-divider>
                    <div>
                      choices.message.tool_calls
                      <span class="next-d">.type</span>
                      <el-tag type="info" size="mini"> {{ model }} </el-tag>
                      <el-tag type="danger" size="mini"> required </el-tag>
                    </div>
                    <p class="nex-c" style="margin-top: 20px">
                      The type of the tool. Currently, only
                      <el-tag type="info" size="mini">function </el-tag> is
                      supported.
                    </p>
                    <div style="margin-top: 25px">
                      <span style="margin-right: 5px">Available options:</span>
                      <el-tag type="info" size="mini">function</el-tag>
                    </div>
                    <el-divider></el-divider>
                    <div>
                      choices.message.tool_calls
                      <span class="next-d">.function</span>
                      <el-tag type="info" size="mini"> object </el-tag>
                      <el-tag type="danger" size="mini"> required </el-tag>
                    </div>
                    <p class="nex-c" style="margin-top: 20px">
                      The function that the model called.
                    </p>
                    <el-collapse style="margin-bottom: 24px" @change="callChange">
                      <el-collapse-item :title="callTitle" name="1">
                        <div>
                          ​ choices.message.tool_calls.function<span
                            class="next-d"
                            >.name</span
                          >
                          <el-tag type="info" size="mini"> string </el-tag>
                          <el-tag type="danger" size="mini"> required </el-tag>
                        </div>
                        <p class="nex-c" style="margin-top: 20px">
                          The name of the function to call.
                        </p>
                        <el-divider></el-divider>
                        <div>
                          choices.message.tool_calls.function<span
                            class="next-d"
                            >.arguments</span
                          >
                          <el-tag type="info" size="mini"> string </el-tag>
                          <el-tag type="danger" size="mini"> required </el-tag>
                        </div>
                        <p class="nex-c" style="margin-top: 20px">
                          The arguments to call the function with, as generated
                          by the model in JSON format. Note that the model does
                          not always generate valid JSON, and may hallucinate
                          parameters not defined by your function schema.
                          Validate the arguments in your code before calling
                          your function.
                        </p>
                      </el-collapse-item>
                    </el-collapse>
                  </el-collapse-item>
                </el-collapse>
                <el-divider></el-divider>
                <div>
                  tools.function <span class="next-d">.parameters</span>
                  <el-tag type="info" size="mini"> string </el-tag>
                </div>
                <p class="nex-c next-a" style="margin-top: 20px">
                  The parameters the functions accepts, described as a JSON
                  Schema object. See the <a href="#">guide </a>for examples, and
                  the <a href="#">JSON Schema reference </a>for documentation
                  about the format.
                </p>
                <p class="nex-c">
                  Omitting
                  <el-tag type="info" size="mini"> parameters </el-tag> defines
                  a function with an empty parameter list.
                </p>
                <el-divider></el-divider>
                <div>
                  tools.function <span class="next-d">.strict</span>
                  <el-tag type="info" size="mini"> boolean | null </el-tag>
                  <el-tag type="info" size="mini"> default:false </el-tag>
                </div>
                <p class="nex-c next-a" style="margin-top: 20px">
                  Whether to enable strict schema adherence when generating the
                  function call. If set to true, the model will follow the exact
                  schema defined in the parameters field. Only a subset of JSON
                  Schema is supported when strict is true. Learn more about
                  Structured Outputs in the
                  <a href="#">function calling guide</a>.
                </p>
              </el-collapse-item>
            </el-collapse>
            <div>
              choices <span class="next-d">.finish_reason
              </span>
              <el-tag type="info" size="mini">{{  model}}</el-tag>
            </div>
            <div style="margin-top: 25px" v-if="stopValue == 'string | null'">
          <span style="margin-right: 5px">Available options:</span>
          <el-tag type="info" size="mini"> stop</el-tag>,
          <el-tag type="info" size="mini"> length</el-tag>,
          <el-tag type="info" size="mini"> tool_calls</el-tag>

        </div>
          </el-collapse-item>
        </el-collapse>
        <!----->

        <div>
          <span class="next-d">created</span
          ><el-tag type="info" size="mini">integer</el-tag>
        </div>
        <el-divider></el-divider>
        <div>
          <span class="next-d">model</span
          ><el-tag type="info" size="mini">string</el-tag>
        </div>
        <el-divider></el-divider>
        <div>
          <span class="next-d">object</span
          ><el-tag type="info" size="mini">{{ menu }}</el-tag>
        </div>

        <div style="margin-top: 25px" v-if="stopValue == 'string | null'">
          <span style="margin-right: 5px">Available options:</span>
          <el-tag type="info" size="mini"> chat.completion.chunk</el-tag>
        </div>
      </div>
      <div v-if="numsb">
        <div style="margin-bottom: 20px">BadRequest</div>
        <div>
          <span class="next-d">code</span
          ><el-tag type="info" size="mini">integer | null</el-tag>
          <el-tag type="info" size="mini">default:false</el-tag>
          <el-tag type="danger" size="mini">required</el-tag>
        </div>
        <div style="margin-top: 25px">
          <span style="margin-right: 5px">Example:</span>
          <el-tag type="info" size="mini">20012</el-tag>
        </div>
        <el-divider></el-divider>

        <span class="next-d">message</span
        ><el-tag type="info" size="mini">string</el-tag>
        <el-tag type="danger" size="mini">required</el-tag>
      </div>
      <div v-if="numsly">
        <div style="margin-bottom: 20px">Unauthorized</div>
        <p class="nex-c">The response is of type string.</p>
        <div style="margin-top: 25px">
          <span style="margin-right: 5px">Example:</span>
          <el-tag type="info" size="mini">"Invalid token"</el-tag>
        </div>
      </div>
      <div v-if="numsls">
        <div style="margin-bottom: 20px">NotFound</div>
        <p class="nex-c">The response is of type string.</p>
        <div style="margin-top: 25px">
          <span style="margin-right: 5px">Example:</span>
          <el-tag type="info" size="mini">"404 page not found"</el-tag>
        </div>
      </div>
      <div v-if="numsrj">
        <div style="margin-bottom: 20px">RateLimit</div>
        <div>
          <span class="next-d">message</span
          ><el-tag type="info" size="mini">string</el-tag>
          <el-tag type="danger" size="mini">required</el-tag>
        </div>
        <div style="margin-top: 25px">
          <span style="margin-right: 5px">Example:</span>
          <el-tag srtle="    text-wrap: auto;" type="info" size="mini"
            >"Request was rejected due to rate limiting. If you want more,
            please contact contact@siliconflow.cn."</el-tag
          >
          <el-tag srtle="    margin-left: 71px;" type="info" size="mini">
            Details:TPM limit reached."</el-tag
          >
        </div>
        <el-divider></el-divider>
        <div>
          <span class="next-d">data</span
          ><el-tag type="info" size="mini">string</el-tag>
          <el-tag type="danger" size="mini">required</el-tag>
        </div>
      </div>
      <div v-if="numwls">
        <div style="margin-bottom: 20px">Overloaded</div>
        <div>
          <span class="next-d">code</span
          ><el-tag type="info" size="mini">integer</el-tag>
          <el-tag type="danger" size="mini">required</el-tag>
        </div>
        <div style="margin-top: 25px">
          <span style="margin-right: 5px">Example:</span>
          <el-tag srtle="    text-wrap: auto;" type="info" size="mini"
            >50505</el-tag
          >
        </div>
        <el-divider></el-divider>
        <div>
          <span class="next-d">message</span
          ><el-tag type="info" size="mini">string</el-tag>
          <el-tag type="danger" size="mini">required</el-tag>
        </div>
        <div style="margin-top: 25px">
          <span style="margin-right: 5px">Example:</span>
          <el-tag srtle="    text-wrap: auto;" type="info" size="mini"
            >"Model service overloaded. Please try again later."</el-tag
          >
        </div>

        <el-divider></el-divider>
        <div>
          <span class="next-d">data</span
          ><el-tag type="info" size="mini">string</el-tag>
          <el-tag type="danger" size="mini">required</el-tag>
        </div>
      </div>
      <div v-if="numwlf">
        <div style="margin-bottom: 20px">Timeout</div>

        <div style="margin-top: 25px">
          <span style="margin-right: 5px">The response is of type:</span>
          <el-tag srtle="    text-wrap: auto;" type="info" size="mini"
            >string.</el-tag
          >
        </div>
      </div>

      <div
        style="
          margin-top: 70px;
          font-size: 14px;
          font-weight: bold;
          overflow: hidden;
          color: rgb(71 69 74);
          cursor: pointer;
        "
      >
        <span style="float: right" @click="goNext">获取用户模型列表 ></span>
      </div>
      <el-divider></el-divider>
      <div>Powered by Mintlify</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nextActive: "LLM",
      model: "enum<string>",
      stopValue: "string | null",
      aa: "enum<string>",
      menu: "enum<string>",
      valueType: "application/json",
      valueNum: "200",
      numellJson: true,
      numellText: false,
      numsb: false,
      numsly: false,
      numsls: false,
      numsrj: false,
      numwls: false,
      numwlf: false,
      sfqTile: "Show child attributes",
      anTitle: "Show child attributes",
      tooTitle: "Show child attributes",
      meTitle: "Show child attributes",
      choTitle:"Show child attributes",
      objTitle:"Show child attributes",
      mesTitle:"Show child attributes",
      callTitle:"Show child attributes",
      usaTitle:"Show child attributes",
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    zlClick() {
      // 说明是200
      if (this.valueType == "application/json") {
        this.numellJson = true;
        this.numellText = false;
        this.numsb = false;
        this.numsly = false;
        this.numsls = false;
        this.numsrj = false;
        this.numwls = false;
        this.numwlf = false;
      } else {
        this.numellJson = false;
        this.numellText = true;
        this.numsb = false;
        this.numsly = false;
        this.numsls = false;
        this.numsrj = false;
        this.numwls = false;
        this.numwlf = false;
      }
    },

    numClick() {
      // 说明是200
      if (this.valueNum == "200") {
        if (this.valueType == "application/json") {
          this.numellJson = true;
          this.numellText = false;
          this.numsb = false;
          this.numsly = false;
          this.numsls = false;
          this.numsrj = false;
          this.numwls = false;
          this.numwlf = false;
        } else {
          this.numellJson = false;
          this.numellText = true;
          this.numsb = false;
          this.numsly = false;
          this.numsls = false;
          this.numsrj = false;
          this.numwls = false;
          this.numwlf = false;
        }
      }
      if (this.valueNum == "400") {
        this.numellJson = false;
        this.numellText = false;
        this.numsly = false;
        this.numsb = true;
        this.numsls = false;
        this.numsrj = false;
        this.numwls = false;
        this.numwlf = false;
      }
      if (this.valueNum == "401") {
        this.numellJson = false;
        this.numellText = false;
        this.numsb = false;
        this.numsly = true;
        this.numsls = false;
        this.numsrj = false;
        this.numwls = false;
        this.numwlf = false;
      }
      if (this.valueNum == "404") {
        this.numellJson = false;
        this.numellText = false;
        this.numsly = false;
        this.numsb = false;
        this.numsls = true;
        this.numsrj = false;
        this.numwls = false;
        this.numwlf = false;
      }
      if (this.valueNum == "429") {
        this.numellJson = false;
        this.numellText = false;
        this.numsly = false;
        this.numsb = false;
        this.numsls = false;
        this.numsrj = true;
        this.numwls = false;
        this.numwlf = false;
      }

      if (this.valueNum == "503") {
        this.numellJson = false;
        this.numellText = false;
        this.numsly = false;
        this.numsb = false;
        this.numsls = false;
        this.numsrj = false;
        this.numwls = true;
        this.numwlf = false;
      }
      if (this.valueNum == "504") {
        this.numellJson = false;
        this.numellText = false;
        this.numsly = false;
        this.numsb = false;
        this.numsls = false;
        this.numsrj = false;
        this.numwls = false;
        this.numwlf = true;
      }
    },
    goNext() {
      this.$router.push({
        path: "/api-reference/platform?type=yhmx",
      });
    },
    sfqChange(activeNames) {
      console.log(activeNames);
      if (activeNames[0] === "1") {
        //  打开的
        this.sfqTile = "Hide child attributes";
      } else {
        this.sfqTile = "Show child attributes";
      }
    },
    anChange(activeNames) {
      console.log(activeNames);
      if (activeNames[0] === "1") {
        //  打开的
        this.anTitle = "Hide child attributes";
      } else {
        this.anTitle = "Show child attributes";
      }
    },
    tooChange(activeNames) {
      console.log(activeNames);
      if (activeNames[0] === "1") {
        //  打开的
        this.tooTitle = "Hide child attributes";
      } else {
        this.tooTitle = "Show child attributes";
      }
    },
    meChange(activeNames) {
      console.log(activeNames);
      if (activeNames[0] === "1") {
        //  打开的
        this.meTitle = "Hide child attributes";
      } else {
        this.meTitle = "Show child attributes";
      }
    },
    choChange(activeNames) {
      console.log(activeNames);
      if (activeNames[0] === "1") {
        //  打开的
        this.choTitle = "Hide child attributes";
      } else {
        this.choTitle = "Show child attributes";
      }
    },
    objChange(activeNames) {
      console.log(activeNames);
      if (activeNames[0] === "1") {
        //  打开的
        this.objTitle = "Hide child attributes";
      } else {
        this.objTitle = "Show child attributes";
      }
    },
    mesChange(activeNames) {
      console.log(activeNames);
      if (activeNames[0] === "1") {
        //  打开的
        this.mesTitle = "Hide child attributes";
      } else {
        this.mesTitle = "Show child attributes";
      }
    },
    callChange(activeNames) {
      console.log(activeNames);
      if (activeNames[0] === "1") {
        //  打开的
        this.callTitle = "Hide child attributes";
      } else {
        this.callTitle = "Show child attributes";
      }
    },
    usaChange(activeNames) {
      console.log(activeNames);
      if (activeNames[0] === "1") {
        //  打开的
        this.usaTitle = "Hide child attributes";
      } else {
        this.usaTitle = "Show child attributes";
      }
    },
  },
};
</script>
<style scoped>
.response-title {
  color: rgb(124 57 238);
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.response-h {
  font-size: 1.875rem;
  line-height: 2.25rem;
  color: #000;
  font-weight: 700;
  margin: 1.1vh 0;
}
.response-d {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.response-i {
  border: 1px solid rgb(228 227 231 / 70%);
  padding: 0.375rem;
  border-radius: 15px;
  width: 97%;
  font-weight: bold;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  /* margin-bottom:12vh */
  /* height: 36px; */
}
.response-i .left {
  color: rgb(29 78 217);
  padding: 3px 9px;
  background: rgba(96, 165, 250, 0.2);
  border-radius: 6px;
  height: 16px;
  line-height: 18px;
  font-size: 0.9rem;
  float: left;
  margin-top: 2px;
  margin-right: 10px;
  font-weight: bold;
}
.response-i-box {
  border: 1px solid rgb(228 227 231 / 70%);
  padding: 0.375rem;
  border-radius: 12px;
  /* width:100%; */
  height: 25px;
  line-height: 30px;
  line-height: 25px;
  flex: 1;
}
.response-btn {
  background-color: rgb(48 100 229);
  height: 25px;
  margin-left: 15px;
  color: #fff;
  font-weight: bold;
  padding: 0.375rem;
  border-radius: 12px;
  width: 65px;
  line-height: 25px;
  padding-left: 1rem;
  cursor: pointer;
}
.next-title {
  color: #000;
  font-weight: 600;
  margin-top: 2em;
  margin-bottom: 0.5em;
  line-height: 1.5;
  font-size: 1.125em;
}
.next-d {
  margin-right: 10px;
  color: rgb(124 57 238);
  font-weight: 600;
}
.next-a {
  margin-top: 20px;
  font-size: 0.875rem;
  line-height: 1.7142857;
  color: #000;
}
.next-a a {
  color: #000;
  text-decoration: none;
  font-weight: 600;
  border-bottom: 1px solid rgb(158 111 251);
}
.nex-c {
  margin-top: 2vh;
  line-height: 25px;
  font-size: 0.875rem;
  /* font-weight: 500; */
}
.next-p {
  font-size: 0.875rem;
}

.response-next {
  margin-top: 5vh /* height: 36px; */;
}

.response-next /deep/.el-tag.el-tag--info {
  color: rgb(86 84 90);
  font-weight: 600;
  margin-right: 10px;
  background: rgb(240 237 244 / 50%);
  color: #363738;
}
.response-next /deep/.el-tag.el-tag--danger {
  color: rgb(221 39 39);
  font-weight: 600;
}
.next-p /deep/.el-tag.el-tag--info {
  margin-right: 0;
  background-color: rgb(244 242 248 / 50%);

  /* color: #363738; */
}
.response-next /deep/.el-tabs__nav-scroll,
.response-next /deep/.el-tabs__content {
  width: auto;
  min-width: auto;
  padding: 0;
}
.response-next /deep/.el-tab-pane {
  padding: 0;
}
.response-next /deep/.el-collapse {
  border-top: none;
  margin-top:24px;
}
.lineSelect {
  float: right;
  font-size: 0.75rem;
  font-weight: 500;
  color: rgb(86 84 90);
}
.lineSelect /deep/.el-input__inner {
  border-color: rgb(255 255 255);
  width: 148px;
}
.lineSelect-num {
  margin-right: 70px;
}
.lineSelect-num /deep/.el-input__inner {
  width: 70px;
}
.hideLine /deep/.el-collapse-item__wrap,
.hideLine /deep/.el-collapse-item__header {
  border-bottom: none;
}
</style>
<style>
.response-line.el-divider--horizontal {
  margin-top: 0.625rem;
  border-color: rgb(242 240 247);
}
.el-collapse-item__header{
  background-color: #fbfafa;
  border-radius: 5px;
  padding-left:10px;
  margin-bottom: 24px;
}
.el-collapse-item__wrap{
  padding:0 20px;
}

</style>